import { useEffect, useState } from "react"
import Table from "../Table"
import MyModal from "../MyModal"
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai"
import actionHelper from "../../lib/actionHelper"
import { toast } from "react-toastify"
import Input from "../Input"
import { createCompany, deleteCompany, editCompany, getCompanyList } from "../../services/companyListApis"

const cols = [
    {
        name: "اسم کمپانی",
        colSpan: 1,
    },
    {
        name: "نام دامنه",
        colSpan: 1,
    },
    {
        name: "توکن",
        colSpan: 1,
    },
    {
        name: "ایپی",
        colSpan: 1,
    },
    {
        name: "سرویس دهنده",
    },
    {
        name: "",
        colSpan: 1,
    },
]

const EditCompanyModal = ({ user, company }) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleModal = () => setIsOpen(!isOpen)

    const submitHandler = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)

        const data = {
            companyId: company.id,
            name: form.get("company-name"),
            apiToken: form.get("api-token"),
            domainIp: form.get("domain-ip"),
            dnsProvider: form.get("dnsProvider") == "on" ? "arvancloud" : "cloudflare",
        }

        if (user) {
            toast
                .promise(editCompany(data), {
                    pending: "درحال ویرایش",
                    success: "ویرایش شد",
                })
                .catch((err) => {
                    if (err.response?.status == 403) {
                        toast.error(err.response.data)
                    }
                    console.error(err)
                })
        }
    }

    return (
        <>
            <button
                onClick={toggleModal}
                className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
            >
                <AiOutlineEdit size="1.7em" className=" hover:fill-yellow-400" />
            </button>
            <MyModal width="400px" height="430px" isOpen={isOpen} toggleModal={toggleModal}>
                <form className="mt-5" onSubmit={submitHandler}>
                    <div>
                        <Input
                            label="نام کمپانی"
                            type="text"
                            name="company-name"
                            placeholder="نام"
                            required={true}
                            defaultValue={company.name}
                        />
                    </div>
                    <div>
                        <Input
                            label="نام دامنه"
                            type="text"
                            name="domain-name"
                            placeholder="دامنه"
                            required={true}
                            defaultValue={company.domain_name}
                        />
                    </div>
                    <div>
                        <Input
                            label="ایپی دامنه"
                            name="domain-ip"
                            placeholder="ایپی"
                            defaultValue={company.domain_ip}
                            required={true}
                        />
                    </div>
                    <div>
                        <Input
                            label="توکن"
                            name="api-token"
                            placeholder="توکن"
                            defaultValue={company.api_token}
                            required={true}
                        />
                    </div>
                    <div className="flex mt-5 my-1 gap-2" dir="rtl">
                        کلودفلر
                        <label class="relative inline-flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                name="dnsProvider"
                                class="sr-only peer"
                                defaultValue={company.dnsProvider == "arvancloud"}
                            />
                            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                        </label>
                        اروان کلود
                    </div>
                    <button type="submit" className="mt-5 w-full styled-button border">
                        ویرایش کمپانی
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const AddCompanyModal = ({ user }) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const submitHandler = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)
        console.log(form.get("dnsProvider"))
        const data = {
            name: form.get("company-name"),
            domainName: form.get("domain-name"),
            apiToken: form.get("api-token"),
            domainIp: form.get("domain-ip"),
            dnsProvider: form.get("dnsProvider") == "on" ? "arvancloud" : "cloudflare",
        }

        if (user) {
            toast
                .promise(createCompany(data), {
                    pending: "درحال اضافه کردن",
                    success: "اضافه شد",
                })
                .catch((err) => {
                    if (err.response?.status == 403) {
                        toast.error(err.response.data)
                    }
                    console.error(err)
                })
        }
    }

    return (
        <>
            <button onClick={toggleModal} className="flex gap-2 w-32 pl-2 styled-button mr-3 mb-3">
                <img src="assets/icons/square-plus.svg" className="h-5 w-5" />
                اضافه کمپانی
            </button>
            <MyModal width="400px" height="430px" isOpen={isOpen} toggleModal={toggleModal}>
                <form className="mt-5" onSubmit={submitHandler}>
                    <div>
                        <Input label="نام کمپانی" type="text" name="company-name" placeholder="نام" required={true} />
                    </div>
                    <div>
                        <Input label="نام دامنه" type="text" name="domain-name" placeholder="دامنه" required={true} />
                    </div>
                    <div>
                        <Input label="ایپی دامنه" name="domain-ip" placeholder="ایپی" required={true} />
                    </div>
                    <div>
                        <Input label="توکن" name="api-token" placeholder="توکن" required={true} />
                    </div>
                    <div className="flex mt-5 my-1 gap-2" dir="rtl">
                        کلودفلر
                        <label class="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" name="dnsProvider" class="sr-only peer" />
                            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                        </label>
                        اروان کلود
                    </div>
                    <button type="submit" className="mt-5 w-full styled-button border">
                        ساخت کمپانی
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const CompanyList = ({ user }) => {
    const [companyList, setCompanyList] = useState(null)
    const updateUi = () => {
        if (user) {
            getCompanyList()
                .then(({ data }) => {
                    data = data.map((company) => {
                        let obj = {
                            name: company.name,
                            domain_name: company.domain_name,
                            api_token: company.api_token,
                            domain_ip: company.domain_ip,
                            provider: company.dnsProvider == "cloudflare" ? "کلودفلر" : "اروان کلود",
                            more: (
                                <div className="flex gap-3 justify-end">
                                    <EditCompanyModal user={user} company={company} />
                                    <button
                                        onClick={() => {
                                            toast.promise(deleteCompany(company.id), {
                                                success: "حذف شد",
                                                pending: "درحال حذف",
                                            })
                                        }}
                                        className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
                                    >
                                        <AiOutlineDelete size="1.7em" className=" hover:fill-red-400" />
                                    </button>
                                </div>
                            ),
                        }
                        return obj
                    })
                    setCompanyList(data)
                })
                .catch((err) => {
                    console.error(err)
                })
        }
    }

    // useEffect(() => {
    //     updateUi()
    // }, [user])

    useEffect(() => {
        updateUi()
        const interval = setInterval(updateUi, 5000)
        return () => clearInterval(interval)
    }, [])

    return (
        <>
            <AddCompanyModal user={user} />
            <Table cols={cols} rows={companyList} paging={{ maxRows: 10 }} />
        </>
    )
}

export default CompanyList
